import { Stack } from "@mui/material";

import { PageContent } from "../../components";

import DashboardPageContent from "./DashboardPageContent";
import DashboardPageBar from "./DashboardPageBar";
import DashboardOverview from "./DashboardOverview";
import { useDashboardFilters } from "./useDashboardFilters";
import { useState } from "react";

export const DashboardPage = () => {
  const filters = useDashboardFilters();
  const [period, setPeriod] = useState("1Q");

  return (
    <PageContent disablePadding>
      <DashboardPageBar period={period} setPeriod={setPeriod} />
      <Stack p="15px" gap="15px" height="100%" overflow="auto">
        <DashboardOverview filters={filters} period={period} />
        <DashboardPageContent filters={filters} period={period} />
      </Stack>
    </PageContent>
  );
};

export default DashboardPage;
